import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './login';
import Home from './Home'; 
import Dashboard from './Dashboard'; 
import Reportservices from './Reportservices'; 
import Voicecommand from './Voicecommand'; 
import Chatbot from './Chatbot'; 
import Chatbotjson from './Chatbotjson'; 
import Analysis from './Analysis'; 




function App() {
  return (
     <>
      <div class="container-fluid">
        <Routes>    
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/home" element={<Home />} />
          <Route path="/dashboard" element={<Dashboard />} />    
          <Route path="/reportservices" element={<Reportservices />} />   
          <Route path="/voicecommand" element={<Voicecommand />} />   
          <Route path="/chatbot" element={<Chatbot />} />   
          <Route path="/chatbotjson" element={<Chatbotjson />} />   
          <Route path="/analysis" element={<Analysis />} />   
        </Routes>       
      </div>
    </>
  );
}

export default App;




// import logo from './logo.svg';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// export default App;